import {
    WS_CONNECT,
    WS_DISCONNECT,
    WS_SEND,
    WS_FOCUS,
    WS_CONNECTED,
    WS_DISCONNECTED,
    WS_RECONNECTING,
    WS_ERROR,
    WS_MESSAGE,
} from '../common/actions/websocketActions';
import * as socketClient from '../utils/socketClient';
import { resolveActions } from './websocketEventHandlers';

/**
 * Redux boundary for the bifrost socket.
 *
 * The socket lifecycle -- tickets, backoff, heartbeat -- belongs to
 * app/utils/socketClient.js. This middleware only translates between that
 * transport and the store, so replacing the transport with a SharedWorker later
 * does not touch the event handling below.
 */

let unsubscribe = null;

const attach = (store) => {
    if (unsubscribe) return;

    unsubscribe = socketClient.subscribe((event) => {
        switch (event.type) {
            case 'open':
                store.dispatch({ type: WS_CONNECTED });
                break;

            case 'close':
                store.dispatch({ type: WS_DISCONNECTED });
                break;

            case 'reconnecting':
                store.dispatch({ type: WS_RECONNECTING });
                break;

            case 'error':
                store.dispatch({ type: WS_ERROR, payload: event.error || 'websocket error' });
                break;

            case 'message': {
                // Published raw as well as mapped, so sagas can correlate a
                // pending creation without going through the action registry.
                store.dispatch({ type: WS_MESSAGE, payload: event.envelope });
                resolveActions(event.envelope, store.getState).forEach(store.dispatch);
                break;
            }

            default:
                break;
        }
    });
};

const websocketMiddleware = (store) => (next) => (action) => {
    switch (action.type) {
        case WS_CONNECT:
            attach(store);
            socketClient.connect(action.payload || {});
            break;

        case WS_DISCONNECT:
            socketClient.disconnect();
            break;

        case WS_SEND:
            socketClient.send(action.payload);
            break;

        case WS_FOCUS:
            socketClient.setFocus(action.payload);
            break;

        default:
            break;
    }

    return next(action);
};

export default websocketMiddleware;
